import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { MdHistory } from "react-icons/md";
import {
  getAllChatSessions,
  getChatSessionByUUID,
} from "../../services/api/ChatService";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "@/components/ui/tooltip";

export function ChatHistoryDialog({ onSelectChatSession, text }) {
  const [chatHistory, setChatHistory] = useState([]);
  const [open, setOpen] = useState(false);

  const handleSelectChatSession = async (session_uuid) => {
    const sessionData = await getChatSessionByUUID(session_uuid);
    if (sessionData) {
      // Handle loading the chat session messages into the chat interface
      console.log("Selected Chat Session Data:", sessionData);
      onSelectChatSession(sessionData);
    }
  };

  useEffect(() => {
    const fetchChatHistory = async () => {
      const sessions = await getAllChatSessions();
      console.log("Fetched Chat Sessions:", sessions);
      if (sessions) {
        setChatHistory(sessions.histories);
      }
    };
    fetchChatHistory();
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <form>
        <DialogTrigger asChild>
          <Button variant="outline">
            <MdHistory />
            <span className={text ? "ml-2" : ""}>{text || ""}</span>
          </Button>
        </DialogTrigger>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Chat History</DialogTitle>
            <DialogDescription>
              View and manage your previous chat sessions here.
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4">
            <div className="grid gap-3 max-h-80 overflow-y-auto">
              {chatHistory.length > 0 &&
                chatHistory.map((chat) => {
                  // Format date to dd-mm-yyyy hh:mm
                  const date = new Date(chat.created_at);
                  const formattedDate = `${date
                    .getDate()
                    .toString()
                    .padStart(2, "0")}-${(date.getMonth() + 1)
                    .toString()
                    .padStart(2, "0")}-${date.getFullYear()} ${date
                    .getHours()
                    .toString()
                    .padStart(2, "0")}:${date
                    .getMinutes()
                    .toString()
                    .padStart(2, "0")}`;
                  return (
                    <div
                      key={chat.sessions_uuid}
                      className="p-2 border rounded flex items-center justify-between cursor-pointer hover:bg-gray-100"
                      onClick={() => {
                        handleSelectChatSession(chat.session_uuid);
                        setOpen(false);
                      }}
                    >
                      <h3 className="text-sm">{chat.name}</h3>
                      <p className="text-xs text-gray-500">{formattedDate}</p>
                    </div>
                  );
                })}
            </div>
          </div>
        </DialogContent>
      </form>
    </Dialog>
  );
}
